import Breadcrumbs from '@mui/material/Breadcrumbs'
import Link from '@mui/material/Link'
import styled from 'styled-components'
import TruncatedTooltipLink from './TruncatedTooltipLink'

const StyledLink = styled(Link)`
  position: relative;
  //font-family: "Work Sans";
  font-size: 11px;
  letter-spacing: 0;
  line-height: 13px;
  text-decoration: none;
  white-space: nowrap;
  max-width: 250px;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;

  // Empty block after text suppresses Safari's native ellipsis tooltip (WebKit).
  &::after {
    content: '';
    display: block;
  }

  &:not(.active-item) {
    &:hover {
      text-decoration: underline;
    }
  }
`;

const StyledBreadcrumbs = styled(Breadcrumbs)`
  ol {
    font-family: "Work Sans";
    font-size: 11px;
    letter-spacing: 0;
    line-height: 13px;
  }
`;

const BreadCrumbs = ({data}) => {
  const list = Object.entries(data.page_breadcrumb)
  const list_length = list.length - 1

  const breadCrumbsList = list.map((item, id) => {
    const isLast = id === list_length
    return (
      <TruncatedTooltipLink
        key={id}
        text={item[1].title}
        // Last item is the current page: no link, styled as active.
        href={isLast ? undefined : item[1].uri}
        component={StyledLink}
        className={isLast ? 'active-item' : undefined}
      />
    )
  })

  return (
    <div role="presentation" className={'online-uitgave-breadcrumb'}>
      <StyledBreadcrumbs aria-label="breadcrumb">
        {breadCrumbsList}
      </StyledBreadcrumbs>
    </div>
  )
}

export default BreadCrumbs
